import React, { useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Paper,
  Alert,
  Collapse,
  IconButton,
  MenuItem,
  styled
} from '@mui/material';
import {
  Event as EventIcon,
  Close as CloseIcon,
  Add as AddIcon
} from '@mui/icons-material';

const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.05)',
  padding: theme.spacing(3),
  borderRadius: theme.spacing(1),
}));

const EventBudgetForm = ({ onSubmit, isSubmitting }) => {
  const [formData, setFormData] = useState({
    eventName: '',
    eventDate: '',
    expectedAttendees: '',
    venue: '',
    totalBudget: '',
    lineItems: [],
    notes: ''
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await onSubmit(formData);
      setSuccess('Event budget submitted successfully!');
      setFormData({
        eventName: '',
        eventDate: '',
        expectedAttendees: '',
        venue: '',
        totalBudget: '',
        lineItems: [],
        notes: ''
      });
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ color: '#00BCD4', mb: 2 }}>
            <EventIcon sx={{ mr: 1 }} />
            Event Budget Planning
          </Typography>
        </Grid>

        {error && (
          <Grid item xs={12}>
            <Alert 
              severity="error"
              action={
                <IconButton size="small" onClick={() => setError(null)}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              }
            >
              {error}
            </Alert>
          </Grid>
        )}

        {success && (
          <Grid item xs={12}>
            <Alert 
              severity="success"
              action={
                <IconButton size="small" onClick={() => setSuccess(null)}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              }
            >
              {success}
            </Alert>
          </Grid>
        )}

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Event Name"
            name="eventName"
            value={formData.eventName}
            onChange={handleChange}
            required
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Event Date"
            name="eventDate"
            type="date"
            value={formData.eventDate}
            onChange={handleChange}
            required
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Expected Attendees"
            name="expectedAttendees"
            type="number"
            value={formData.expectedAttendees}
            onChange={handleChange}
            required
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Venue"
            name="venue"
            value={formData.venue}
            onChange={handleChange}
            required
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Total Budget"
            name="totalBudget"
            type="number"
            value={formData.totalBudget}
            onChange={handleChange}
            required
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Notes"
            name="notes"
            multiline
            rows={4}
            value={formData.notes}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            fullWidth
            type="submit"
            variant="contained"
            disabled={isSubmitting}
            sx={{
              backgroundColor: '#00BCD4',
              '&:hover': {
                backgroundColor: '#00ACC1',
              },
              '&:disabled': {
                backgroundColor: 'rgba(0, 188, 212, 0.5)',
              }
            }}
          >
            {isSubmitting ? 'Submitting...' : 'Submit Budget'}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EventBudgetForm; 